import { Box, portexColor, styled } from "@portex-pro/ui-components";

const ZebraView = styled(Box)(() => ({
  "& > *:nth-child(even)": {
    backgroundColor: portexColor.grey50,
  },
}));

export default ZebraView;
